import { HeaderScrollDirectiveModule } from 'directives/headerScroll.directive';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { StatusPageModule } from 'components/statusPage/statusPage.module';
import { SaveBarModule } from 'components/savebar/savebar.module';
import { SearchDirectiveModule } from 'components/search/search.directive';
import { VideoSliderServiceModule } from 'components/videoSlider/videoSlider.service';
import { TrialServiceModule } from 'components/trial/trial.service';
import { PageHeaderComponentModule } from './pageHeader.component';
import { BackButtonComponentModule } from './backButton/backButton';
import { TabsComponentModule } from './tabs/tabs';
import { CalendlyButtonComponentModule } from './calendlyLauncher/calendlyButton';
import { SupportPinComponentModule } from './supportPin/supportPin';
import { OverflowMenuBulkProcessModule } from './overflowMenu/overflowMenuBulkProcess';
import { OverflowMenuCalendlyComponentModule } from './overflowMenu/overflowMenuCalendly';
import { OverflowMenuComponentModule } from './overflowMenu/overflowMenu';
import { OverflowMenuHelpComponentModule } from './overflowMenu/overflowMenuHelp';
import { OverflowMenuIntercomComponentModule } from './overflowMenu/overflowMenuIntercom';
import { OverflowMenuLogoutComponentModule } from './overflowMenu/overflowMenuLogout';
import { OverflowMenuSearchComponentModule } from './overflowMenu/overflowMenuSearch';
import { OverflowMenuStorefrontCacheModule } from './overflowMenu/overflowMenuStorefrontCache';
import { OverflowMenuStorefrontPreviewComponentModule } from './overflowMenu/overflowMenuStorefrontPreview';

export const PageHeaderModule = angular
    .module('app.components.pageHeader', [
        HeaderScrollDirectiveModule,
        StatusPageModule,
        SaveBarModule,
        SearchDirectiveModule,
        PageHeaderComponentModule,
        BackButtonComponentModule,
        TabsComponentModule,
        LaunchDarklyServiceModule,
        VideoSliderServiceModule,
        TrialServiceModule,
        CalendlyButtonComponentModule,
        SupportPinComponentModule,
        OverflowMenuComponentModule,
        OverflowMenuHelpComponentModule,
        OverflowMenuIntercomComponentModule,
        OverflowMenuCalendlyComponentModule,
        OverflowMenuLogoutComponentModule,
        OverflowMenuSearchComponentModule,
        OverflowMenuStorefrontPreviewComponentModule,
        OverflowMenuBulkProcessModule,
        OverflowMenuStorefrontCacheModule

    ]).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/pageHeader.module.js